import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Loading, StatusBadge, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { splitListItems } from "@/lib/utils";
import { ShieldCheck } from "lucide-react";

export default function MyAuthorizations() {
  const { data, isLoading } = useQuery({ queryKey: ["myAuth"], queryFn: async () => (await api.get("/my/authorizations")).data });
  if (isLoading) return <Loading />;
  return (
    <div>
      <PageHeader overline="Competence" title="My Authorizations" icon={ShieldCheck}
        subtitle="Activities and equipment you are currently authorized to perform." />
      {(data || []).length === 0 ? (
        <EmptyState icon={ShieldCheck} title="No active authorizations" hint="Authorizations are granted and reviewed by HR." />
      ) : (
        <Card className="border-slate-200 shadow-none overflow-hidden">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead className="overline text-slate-500">Activity</TableHead>
              <TableHead className="overline text-slate-500">Status</TableHead>
              <TableHead className="overline text-slate-500">Effective</TableHead>
              <TableHead className="overline text-slate-500">Review / Expiry</TableHead>
              <TableHead className="overline text-slate-500">Approver</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {data.map((a) => {
                const items = splitListItems(a.activity);
                return (
                  <TableRow key={a.id} className="table-row-i" data-testid={`my-auth-${a.id}`}>
                    <TableCell className="font-medium text-navy align-top">
                      {items.length > 1 ? (
                        <ul className="space-y-1">
                          {items.map((item, i) => (
                            <li key={i} className="flex items-start gap-1.5">
                              <span className="h-1 w-1 rounded-full bg-teal/60 mt-1.5 shrink-0" />{item}
                            </li>
                          ))}
                        </ul>
                      ) : items[0] || "—"}
                    </TableCell>
                    <TableCell className="align-top"><StatusBadge status={a.status === "Authorized" ? "Active" : a.status} /></TableCell>
                    <TableCell className="text-slate-600 align-top">{a.effective_from || "—"}</TableCell>
                    <TableCell className="text-slate-600 align-top">{a.expiry_date || a.review_date || "—"}</TableCell>
                    <TableCell className="text-slate-600 align-top">{a.approver || "—"}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
